//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'

export default {
  props: {
    force: { type: Boolean, default: false },
    fullScreen: { type: Boolean, default: true },
    standalone: { type: Boolean, default: false }
  },
  data: () => ({
    loadingCounter: 0,
    loading: false
  }),
  computed: {
    ...mapGetters({
      outstandingRequests: 'page/outstandingRequests'
    }),
    totalLoadingCounter () {
      return this.loadingCounter + Object.keys(this.outstandingRequests).length
    }
  },
  watch: {
    totalLoadingCounter (count) {
      if (count === 0) this.stopLoading()
      else this.loading = true
    }
  },
  mounted () {
    this.stopLoading = this.debounce(this.stopLoading, 500)
    this.startPolling()
  },
  beforeDestroy () {
    this.stopPolling()
  },
  methods: {
    start () {
      this.loadingCounter += 1
    },
    finish () {
      this.loadingCounter -= 1
    },
    stopLoading () {
      this.loading = false
    },
    startPolling () {
      this.pollingInterval = setInterval(this.poll, 500)
    },
    stopPolling () {
      clearInterval(this.pollingInterval)
    },
    poll () {
      // Check if any requests are older than the limit
      const timedOutRequests = Object.entries(this.outstandingRequests).filter(
        ([compareUid, { start, timeout }]) => (start + timeout < (new Date()).valueOf())
      )

      if (timedOutRequests.length) {
        this.$store.commit('page/TIMEOUT_REQUESTS')
      }
    }
  }
}
